import { render } from "./PurchaseHouseAnalysisReport.vue?vue&type=template&id=1fa1cf6a&scoped=true"
import script from "./PurchaseHouseAnalysisReport.vue?vue&type=script&lang=js"
export * from "./PurchaseHouseAnalysisReport.vue?vue&type=script&lang=js"

import "./PurchaseHouseAnalysisReport.vue?vue&type=style&index=0&id=1fa1cf6a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa1cf6a"]])

export default __exports__